<template>
  <div>
    <div v-if="appointment.title || appointment.department">
      <strong>{{ appointment.title + ', ' + appointment.department }}</strong>
    </div>
    <div v-if="appointment.institution_name || appointment.institution_location">
      <span>{{ appointment.institution_name + ', ' + appointment.institution_location }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    appointment: {
      type: Object,
      default: null,
    },
  },
};
</script>
